import { Link } from 'react-router-dom'
import { SwitchAccount } from '../components/switch-account'
import { ContactList } from '../components/contact-list'
// import IconMore from '../../../../media/shared-access/ic-more.svg'
import { ContactDetails } from '../components/contact-details'
import { useState } from 'react'
import { AddContact } from '../components/add-contact'
import { useEffect } from 'react'
import { getContactGroups, getContacts, getMailers, getUserInfo } from '../core/_requests'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'
import { useAuth } from '../../../../app/modules/auth'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { PageTitle } from '../../../../_metronic/layout/core'
import { SharedAccessBreadCrum } from '../core/_constants'

export const Contacts = () => {
  function handleContactOptions(type: string) {
    setIsNewContactActive(type)
  }
  const { mode } = useThemeMode()
  const { formatMessage } = useIntl() // eslint-disable-line
  const { companyId, currentUser } = useAuth() // eslint-disable-line
  const [contacts, setcontacts] = useState([])
  const [isNewContactActive, setIsNewContactActive] = useState('Detail')
  const [selectedContact, setselectedContact] = useState<any>({})
  const [groups, setgroups] = useState([])
  const [userInfo, setuserInfo] = useState('')
  const [isUserConnected, setisUserConnected] = useState(false)
  const [accountType, setaccountType] = useState('')
  const [isSubmittingContact, setIsSubmittingContact] = useState(false)
  const [isContactLoading, setisContactLoading] = useState(false)
  const [isGroupLoading, setIsGroupLoading] = useState(false)
  const [userLoading, setuserLoading] = useState(false)
  const [connectorLoading, setconnectorLoading] = useState(false)
  const [nextContactPage, setnextContactPage] = useState(false)
  const [nextPageContactToken, setnextPageContactToken] = useState('')

  const getAllContacts = async () => {
    setisContactLoading(true)
    try {
      const {
        data: { success, data },
      } = await getContacts(companyId!, nextPageContactToken)
      if (success) {
        console.log(success, data, 'check all user data')
        if (data?.nylasContacts?.nextCursor) {
          setnextContactPage(true)
          setnextPageContactToken(data?.nylasContacts?.nextCursor)
        } else {
          setnextContactPage(false)
          setnextPageContactToken('')
        }
        setcontacts((prevContacts) =>
          nextContactPage ? [...prevContacts, ...data.nylasContacts.data] : data.nylasContacts.data
        )
        setselectedContact(data.nylasContacts.data?.slice(-6)[0])
      } else {
        toast.error(formatMessage({ id: 'Something went wrong while fetching contacts.' }))
      }
    } catch (err) {
      toast.error(formatMessage({ id: 'something went wrong' }))
    } finally {
      setisContactLoading(false)
    }
  }

  const getAllGroups = async () => {
    setIsGroupLoading(true)
    try {
      const {
        data: { success, data },
      } = await getContactGroups(companyId!)
      if (success) {
        console.log(data.nylasContactGroups.data, 'check all user data')
        const filteredGroupData = data.nylasContactGroups.data.filter(
          (group: any) =>
            group.groupType === 'user' || group.name === 'starred' || group.name === 'myContacts'
        )

        setgroups(filteredGroupData)
      } else {
        toast.error(formatMessage({ id: 'Something went wrong while fetching groups.' }))
      }
    } catch (err) {
      toast.error(formatMessage({ id: 'something went wrong' }))
    } finally {
      setIsGroupLoading(false)
    }
  }

  const getUserInformation = async () => {
    setuserLoading(true)
    try {
      const {
        data: { success, data },
      } = await getUserInfo(companyId!)
      if (success) {
        console.log(data.account.data.email, 'check all user info')
        setuserInfo(data.account.data.email)
      } else {
        toast.error(formatMessage({ id: 'Something went wrong while fetching user Information.' }))
      }
    } catch (err) {
      toast.error(formatMessage({ id: 'something went wrong' }))
    } finally {
      setuserLoading(false)
    }
  }

  const getMailerInformation = async () => {
    setconnectorLoading(true)
    try {
      const {
        data: { success, data },
      } = await getMailers(companyId!)
      if (success) {
        console.log(data.isNylasActive, 'mailers')

        if (data.isNylasActive === 'nylasGoogle' || data.isNylasActive === 'nylasMicrosoft') {
          setaccountType(data.isNylasActive)
          setisUserConnected(true)
          getAllGroups()
          getAllContacts()
          getUserInformation()
        } else {
          toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
            autoClose: false,
            closeOnClick: true,
          })
        }
      } else {
        toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
          autoClose: false,
          closeOnClick: true,
        })
      }
    } catch (err) {
      toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
        autoClose: false,
        closeOnClick: true,
      })
    } finally {
      setconnectorLoading(false)
    }
  }

  useEffect(() => {
    getMailerInformation()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle
        breadcrumbs={SharedAccessBreadCrum}
        description={formatMessage({ id: 'Contacts' })}
      >
        {formatMessage({ id: 'Shared Access' })}
      </PageTitle>
      <div className='app-main flex-column flex-row-fluid'>
        <div className='d-flex flex-column flex-column-fluid'>
          <div className='app-content flex-column-fluid'>
            <div>
              <div className='row g-7'>
                <div className='col-xl-3'>
                  <div
                    className='mb-4 rounded'
                    style={mode !== 'dark' ? { background: '#fff' } : { background: '#1e1e2d' }}
                  >
                    <div className='col-xl-12 col-12'>
                      <SwitchAccount
                        userInfo={userInfo}
                        isUserConnected={isUserConnected}
                        accountType={accountType}
                        userLoading={userLoading}
                        connectorLoading={connectorLoading}
                      />
                    </div>
                  </div>
                  <div className='card card-flush'>
                    <div className='card-body'>
                      <div className='d-flex flex-column gap-5'>
                        <div className=''>
                          <h2 className='text-dark fw-bold fs-4'>
                            {formatMessage({ id: 'Contacts' })}
                          </h2>
                          <Link
                            to='#'
                            className={`btn bg-primary custom-button-property text-white fw-normal w-100 mt-2 ${!isUserConnected && 'disabled'
                              }`}
                            onClick={() => {
                              // setAddContact(true)
                              setIsNewContactActive('Add')
                            }}
                          >
                            <p className='m-0 text-white'>{formatMessage({ id: 'New contact' })}</p>
                          </Link>
                        </div>
                        <div className='seperator'></div>

                        <div
                          className='d-flex flex-stack bg-light rounded'
                          style={{
                            padding: '8px',
                            // backgroundColor: '#F3F6F9',
                            color: '#4776E6',
                          }}
                        >
                          <Link to='#' className='fw-semibold text-hover-primary'>
                            <p className='m-0 text-dark'>{formatMessage({ id: 'All Contacts' })}</p>
                          </Link>
                          <div
                            className='`badge badge-light-primary'
                            style={{
                              padding: '4px 8px 4px 8px',
                              backgroundColor: '#E8FFF3',
                              color: '#50CD89',
                              borderRadius: '6px',
                            }}
                          >
                            {contacts?.length ? contacts?.length - 1 : 0}
                          </div>
                        </div>

                        <div className='seperator'></div>

                        <div>
                          <h2 className='text-dark fw-bold fs-4'>
                            {formatMessage({ id: 'Groups' })}
                          </h2>
                        </div>
                        <div className='gap-2'>
                          {connectorLoading ? (

                            <div className='mb-3' style={{ width: '100%' }}>
                              <Skeleton
                                height={40}
                                count={10}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                          ) : isUserConnected ? (
                            isGroupLoading ? (
                              <div className='' style={{ width: '100%' }}>
                                <Skeleton
                                  height={40}
                                  count={10}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                            ) : (
                              groups?.map((group: any, index) => {
                                console.log('group dataaaa', group)
                                return (
                                  <div
                                    key={index}
                                    className='d-flex flex-stack bg-hover-light rounded'
                                    style={{ padding: '8px 8px 8px 8px ' }}
                                  >
                                    <Link
                                      to='#'
                                      className='fw-semibold text-gray-800 text-hover-primary'
                                    >
                                      {group?.name}
                                    </Link>
                                  </div>
                                )
                              })
                            )
                          ) : (
                            <div className='d-flex flex-stack'>
                              <Link to='#' className='fw-semibold text-gray-800 text-hover-primary'>
                                {formatMessage({ id: 'starred' })}
                              </Link>
                            </div>
                          )}
                        </div>

                        <div className='seperator'></div>
                        {/* <div className='d-flex flex-stack'>
                          <Link to='#' className='fw-semibold text-danger'>
                            Blocked Contacts
                          </Link>
                          <div className='`badge badge-light-danger fw-normal'>200</div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-xl-3'>
                  <ContactList
                    setselectedContact={setselectedContact}
                    selectedContact={selectedContact}
                    contacts={contacts}
                    setcontacts={setcontacts}
                    handleContactOptions={handleContactOptions}
                    isUserConnected={isUserConnected}
                    isSubmittingContact={isSubmittingContact}
                    isContactLoading={isContactLoading}
                    connectorLoading={connectorLoading}
                    nextContactPage={nextContactPage}
                    getAllContacts={getAllContacts}
                  />
                </div>

                <div className='col-xl-6'>
                  {isNewContactActive !== 'Detail' ? (
                    <AddContact
                      selectedContact={selectedContact}
                      isNewContactActive={isNewContactActive}
                      groups={groups}
                      setIsNewContactActive={setIsNewContactActive}
                      setcontacts={setcontacts}
                      setselectedContact={setselectedContact}
                      isSubmitting={isSubmittingContact}
                      setIsSubmitting={setIsSubmittingContact}
                    />
                  ) : isUserConnected ? (
                    <ContactDetails
                      selectedContact={selectedContact || {}}
                      setselectedContact={setselectedContact}
                      contacts={contacts}
                      setcontacts={setcontacts}
                      handleContactOptions={handleContactOptions}
                      isUserConnected={isUserConnected}
                      setIsNewContactActive={setIsNewContactActive}
                    />
                  ) : (
                    <div className='card' id='kt_contacts_main' style={{ height: '100%' }}>
                      <div
                        className='card d-flex py-20 py-xl-0 justify-content-center align-items-center'
                        id='kt_contacts_main'
                        style={{ height: '100%' }}
                      >
                        <div className='text-center align-items-center justify-content-center px-20'>
                          <img
                            src={toAbsoluteUrl('media/illustrations/contactIllust.png')}
                            alt={formatMessage({ id: 'No Contacts' })}
                            className='mb-8'
                            width={350}
                            height={250}
                          />
                          <h2 className='text-dark fw-bold fs-2 mb-4'>
                            {formatMessage({ id: 'Welcome to the Contacts App' })}
                          </h2>

                          <p className='text-gray-800 fs-8 text-center'>
                            {formatMessage({
                              id: "It's time to expand our contacts. Kickstart your contacts growth by connecting your account.",
                            })}
                          </p>

                          <Link
                            to='/setting/company-settings?tab=integration'
                            className='btn bg-primary custom-button-property text-white fw-normal mt-2'
                            onClick={() => {
                              // handle button action here
                            }}
                          >
                            <p className='m-0 text-white'>{formatMessage({ id: 'Connect Your Account Now' })}</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
